<svg class="MediaControlsIconPlay" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M83.9689 60.0003L44.9102 82.5508L44.9102 37.4497L83.9689 60.0003Z" />
</svg>
